import "@/App.css";
import { useState, useCallback } from 'react';
import { LanguageProvider } from './context/LanguageContext';
import Navigation from './components/Navigation';
import WelcomePopup from './components/WelcomePopup';
import FAQModal from './components/FAQModal';
import HeroSection from './components/HeroSection';
import PainSection from './components/PainSection';
import SatyaSection from './components/SatyaSection';
import AboutSection from './components/AboutSection';
import TrustStats from './components/TrustStats';
import ServicesSection from './components/ServicesSection';
import TestimonialsSection from './components/TestimonialsSection';
import ContactForm from './components/ContactForm';
import BookCallBanner from './components/BookCallBanner';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';
import FloatingWhatsApp from './components/FloatingWhatsApp';
import AccessibilityModal from './components/AccessibilityModal';
import TermsModal from './components/TermsModal';
import PrivacyModal from './components/PrivacyModal';
import CardGameModal from './components/CardGameModal';
import InstagramFeed from './components/InstagramFeed';
import CalendlyModal from './components/CalendlyModal';

// Background image URL
const BG_IMAGE = process.env.REACT_APP_BG_IMAGE || "https://customer-assets.emergentagent.com/job_satya-self/artifacts/ylnd2451_Screenshot%202025-09-12%20at%2021.39.28.png";

function App() {
  const [isFAQOpen, setIsFAQOpen] = useState(false);
  const [isAccessibilityOpen, setIsAccessibilityOpen] = useState(false);
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const [isCardGameOpen, setIsCardGameOpen] = useState(false);
  const [isCalendlyOpen, setIsCalendlyOpen] = useState(false);

  const openCalendly = useCallback(() => setIsCalendlyOpen(true), []);

  return (
    <LanguageProvider>
      <div className="App min-h-screen relative" data-testid="app-container">
        {/* Fixed Background Image */}
        <div 
          className="fixed inset-0 z-0"
          style={{
            backgroundImage: `url(${BG_IMAGE})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            opacity: 0.15
          }}
        />
        
        {/* Content wrapper */}
        <div className="relative z-10">
          {/* Navigation */}
          <Navigation onFAQClick={() => setIsFAQOpen(true)} isFAQOpen={isFAQOpen} onCardGameClick={() => setIsCardGameOpen(true)} onBookCall={openCalendly} />
          
          {/* Welcome Popup (appears on first visit) */}
          <WelcomePopup />
          
          {/* FAQ Modal */}
          <FAQModal isOpen={isFAQOpen} onClose={() => setIsFAQOpen(false)} />
          
          {/* Accessibility Modal */}
          <AccessibilityModal isOpen={isAccessibilityOpen} onClose={() => setIsAccessibilityOpen(false)} />
          
          {/* Terms Modal */}
          <TermsModal isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)} />
          
          {/* Privacy Modal */}
          <PrivacyModal isOpen={isPrivacyOpen} onClose={() => setIsPrivacyOpen(false)} />
          
          {/* Card Game Modal */}
          <CardGameModal isOpen={isCardGameOpen} onClose={() => setIsCardGameOpen(false)} onBookCall={openCalendly} />
        
          {/* CONVERSION FUNNEL ORDER:
              1. Hero - Hook + CTA
              2. Pain Points - Identify with visitor
              3. About - Build trust & authority
              4. Trust Stats - Social proof numbers
              5. Satya Method - Explain the solution
              6. Services - What you offer
              7. Testimonials - Social proof stories
              8. Book Call - Secondary CTA
              9. Contact Form - Primary conversion
          */}
          
          {/* 1. Hero Section */}
          <div className="pt-36 md:pt-40">
            <HeroSection onBookCall={openCalendly} />
          </div>
          
          {/* 2. Pain Points */}
          <PainSection />
          
          {/* 3. About - Trust & Authority */}
          <AboutSection />
          
          {/* 4. Trust Stats Bar */}
          <TrustStats />
          
          {/* 5. Satya Method */}
          <SatyaSection />
          
          {/* 6. Services */}
          <ServicesSection />
          
          {/* 7. Testimonials - Social Proof */}
          <TestimonialsSection />
          
          {/* 8. Instagram Feed */}
          <InstagramFeed />
          
          {/* 9. Book Call Banner */}
          <BookCallBanner onBookCall={openCalendly} />
          
          {/* 9. Contact Form */}
          <ContactForm />
          
          {/* Footer */}
          <Footer 
            onAccessibilityClick={() => setIsAccessibilityOpen(true)} 
            onTermsClick={() => setIsTermsOpen(true)}
            onPrivacyClick={() => setIsPrivacyOpen(true)}
          />
          
          {/* Cookie Banner */}
          <CookieBanner />
          
          {/* Floating WhatsApp */}
          <FloatingWhatsApp />

          {/* Calendly Modal */}
          <CalendlyModal isOpen={isCalendlyOpen} onClose={() => setIsCalendlyOpen(false)} />
        </div>
      </div>
    </LanguageProvider>
  );
}

export default App;
